import React from 'react';
import { TranslationView } from '@levelapp/softfabric-ui';
import { Image, Text, View } from 'react-native';
import Helpers from '../../../../../Common/Helpers/AmountHelpers';
import Translation from "../../../../../Common/DTO/Translation";
import {styles} from "./WarningViewStyle";

interface WarningViewProps {
  text: Translation;
}

export const WarningView = ({text}: WarningViewProps) => {

    return (
      <View style={styles.page}>
          <View style={[{flexDirection: 'row', alignItems: 'center'}]}>
              <Image source={require('./assets/info.png')} style={{ height: 56, width: 56, marginRight: 18 }} />
              <TranslationView style={styles.title}>warning</TranslationView>
          </View>
          <Text style={styles.text}>{Helpers.getCorrectTranslation(text)}</Text>
      </View>

    );
}

export default WarningView;